import React from "react";
import styled from "styled-components";

const Section = styled.section`
  background: #f8f9fa;
  padding: 64px 0 48px 0;
  border-bottom: 1.5px solid #222;
`;

const Title = styled.h2`
  font-size: 2rem;
  font-weight: 800;
  color: #222;
  text-align: center;
  margin-bottom: 32px;
  letter-spacing: 1px;
  @media (max-width: 600px) {
    font-size: 1.3rem;
    margin-bottom: 18px;
  }
`;

const AboutText = styled.p`
  max-width: 700px;
  margin: 0 auto;
  color: #444;
  font-size: 1.15rem;
  text-align: center;
  line-height: 1.7;
  @media (max-width: 600px) {
    font-size: 1rem;
    padding: 0 8px;
  }
`;

const About = () => (
  <Section id="sobre">
    <Title>Sobre a Prisma</Title>
    <AboutText>
      A PRISMA é uma empresa de assessoria educacional e organizacional que atua
      de forma integrada nas dimensões administrativa e pedagógica. Seu
      propósito é apoiar instituições de ensino, mantenedoras e organizações na
      construção de processos mais eficientes, humanos e sustentáveis.
      <br />
      <br />
      Combinando profundo conhecimento da legislação educacional, experiência
      prática, análise estratégica e um olhar acolhedor, a PRISMA desenvolve
      soluções personalizadas que fortalecem a gestão, qualificam as práticas
      pedagógicas e colocam as pessoas no centro de toda transformação.
      <br />
      <br />
      Mais do que uma prestadora de serviços, a PRISMA se posiciona como
      parceira de confiança, caminhando lado a lado com cada instituição para
      transformar desafios em oportunidades e potencial em resultados
      duradouros.
    </AboutText>
  </Section>
);

export default About;
